import ConfirmationModal from "~/common/components/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { IMG_EMPTY_CART } from "~/utils/url/staticResources";
import CenterContents from "~/common/components/CenterContents";
import { styled } from "~/common/mui";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";
import Delete from "~/common/mui/icons/Delete";

export const ModalTitle = styled("h1")({
  ...getFontStyle(FontSize.HeadlineSmall),
  paddingTop: "24px",
  paddingBottom: "16px",
});

interface Props {
  onOk?: () => void;
  onCancel: () => void;
  messageKey?: string;
}

const DeleteCartConfirmationModal = ({ messageKey = "deleteConfirmation.cart", ...props }: Props) => {
  const { t } = useTranslation();

  const ok = t("deleteConfirmation.button");
  const cancel = t("contactUsPage.form.cancel");

  const isTablet = useIsMinTabletSize();

  return (
    <ConfirmationModal
      okLabel={ok}
      cancelLabel={cancel}
      slotProps={{
        okButton: {
          color: "error",
          startIcon: <Delete />,
        },
      }}
      {...props}
    >
      {isTablet ? (
        <h3 className="title-large">{t(messageKey)}</h3>
      ) : (
        <CenterContents className={"d-flex flex-direction-column f-center"}>
          <h1 className="headline-small">{t(messageKey)}</h1>
          <img className="mt-4" src={IMG_EMPTY_CART} />
        </CenterContents>
      )}
    </ConfirmationModal>
  );
};

export default DeleteCartConfirmationModal;
